import React from "react";
import { Col, Divider, Empty, Form, Modal, Row, Spin } from "antd";
import { useAccounts } from "hook/finance/withdraw/useWithdraw";
import CardAccount from "component/cards/payment/account/card_account";
import { useSelector } from "react-redux";
import { defaultBankAllSelector } from "store/bailiff/default/bank/default_bank.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str

const DialogAccount = () => {
  // -------------------------- VAR -----------------------------
  const { handleCancel } = useAccounts();
  const form = Form?.useFormInstance();
  const openAccount = Form?.useWatch("openAccount", form) || false;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const data = useSelector(defaultBankAllSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderEmpty = () => {
    if (data?.length === 0) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 200,
          }}
        >
          <Empty description="Danh bạ người nhận đang trống" />
        </div>
      );
    }
  };

  const renderLoading = () => {
    if (data === null) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 200,
          }}
        >
          <Spin size="large" tip="Đang tải danh bạ" />
        </div>
      );
    }
  };

  const renderLists = () => {
    if (data?.length > 0) {
      return (
        <Row gutter={[10, 10]}>
          {data?.map((item, index) => {
            return (
              <Col key={item?.id} xl={24} lg={24} md={24} xs={24}>
                <CardAccount data={item} index={index} />
              </Col>
            );
          })}
        </Row>
      );
    }
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      centered
      title="Danh bạ người nhận"
      open={openAccount}
      onCancel={() => handleCancel(form)}
      footer={null}
    >
      <Divider style={{ margin: "10px 0px" }} />
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          {renderLoading()}
          {renderEmpty()}
          {renderLists()}
        </Col>
      </Row>
    </Modal>
  );
};
export default DialogAccount;
